import {Box, Button, ButtonBase, CircularProgress, Divider, styled} from "@mui/material";
import FlexBox from "components/FlexBox";
import {H6, Small, Tiny} from "components/Typography";
import UkoAvatar from "components/UkoAvatar";
import {FC, Fragment, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import PopoverLayout from "./PopoverLayout";
import {useAppDispatch, useAppSelector} from "../../../hooks/useRedux";
import {logout} from "../../../store/authSlice";
import {LogoutRounded} from "@mui/icons-material";

// styled components
const StyledSmall = styled(Small)(({theme}) => ({
    display: "block",
    padding: "5px 1rem",
    cursor: "pointer",
    "&:hover": {
        color: theme.palette.primary.main,
        backgroundColor:
            theme.palette.mode === "light"
                ? theme.palette.secondary.light
                : theme.palette.divider,
    },
}));

const ProfilePopover: FC = () => {
    const authSelector = useAppSelector(state => state.auth)
    const dispatch = useAppDispatch()
    const anchorRef = useRef(null)
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)

    const handleMenuItem = (path: string) => {
        navigate(path);
        setOpen(false);
    }

    return (
        <Fragment>
            <ButtonBase disableRipple ref={anchorRef} onClick={() => setOpen(true)}>
                <UkoAvatar
                    src={"/static/avatar/001-man.svg"}
                    sx={{width: 30, height: 30, ml: 1}}
                />
            </ButtonBase>

            <PopoverLayout
                hiddenViewButton
                maxWidth={250}
                minWidth={200}
                popoverOpen={open}
                anchorRef={anchorRef}
                popoverClose={() => setOpen(false)}
                title={
                    <FlexBox alignItems="center">
                        <UkoAvatar
                            src={authSelector.user?.avatar || "/static/avatar/001-man.svg"}
                            sx={{width: 35, height: 35}}
                        />

                        <Box ml={1}>
                            <H6>{authSelector.user?.name}</H6>
                            <Tiny display="block" fontWeight={500} color="text.disabled">
                                {authSelector.user?.email}
                            </Tiny>
                        </Box>
                    </FlexBox>
                }>
                <Box pt={1}>

                    <StyledSmall
                        onClick={() => handleMenuItem("/dashboard/user-profile")}>
                        Paramètres
                    </StyledSmall>

                    <Divider sx={{my: 1}}/>

                    <Button color={"error"} fullWidth variant={"text"} size={"small"} endIcon={<LogoutRounded/>}
                            onClick={() => dispatch(logout())}>
                        {authSelector.isLoggingOut ? <CircularProgress size={"1rem"}/> : "Déconnexion"}
                    </Button>
                </Box>
            </PopoverLayout>
        </Fragment>
    );
};

export default ProfilePopover;
